import { appendTestableComponentAttributes, Tooltip } from '@dreryk/react-components';

import { StyledSectionChip } from './SectionChip.styled';
import { formatChipLabel } from './SectionChip.utils';
import { SectionChipTooltip } from './SectionChipTooltip';
import { DeepLinkTarget, SectionSummary } from './SectionSummary.types';

type SectionChipProps = {
   readonly summary: SectionSummary;
   readonly onDetails: (target: DeepLinkTarget) => void;
};

export const SectionChip = (props: SectionChipProps): JSX.Element => {
   const renderTooltipContent = (hideTooltip: VoidFunction): JSX.Element => (
      <SectionChipTooltip summary={props.summary} onDetails={props.onDetails} hideTooltip={hideTooltip} />
   );

   return (
      <Tooltip testId={`sectionChipTooltip-${props.summary.sectionId}`} content={renderTooltipContent}>
         <StyledSectionChip
            alignItems={'center'}
            {...appendTestableComponentAttributes('SectionChip', `${props.summary.sectionId}`)}
         >
            {formatChipLabel(props.summary)}
         </StyledSectionChip>
      </Tooltip>
   );
};
